
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { interval } from 'rxjs/observable/interval';

export class TicketService {

  private timeLeft$ = new BehaviorSubject<number>(0);
  private isOver$ = new BehaviorSubject<boolean>(false);

  public setIsOver(): void {
    this.isOver$.next(true);
  }

  public setTimeLeft(timeLeft: number): void {
    this.timeLeft$.next(timeLeft);
  }

  public getIsOver(): Observable<boolean> {
    return this.isOver$
      .asObservable()
      .distinctUntilChanged();
  }

  public calculateTime(): Observable<any> {
    return interval(50)
      .combineLatest(this.getTimeLeft())
      .switchMap(([, time]) => {
        const newTime = time - new Date().getTime();
        if (newTime <= 0) {
          this.setIsOver();
        }
        return Observable.of(newTime / 1000);
      }).takeWhile(time => time > 0);
  }

  public getTimeLeft(): Observable<any> {
    return this.timeLeft$.asObservable();
  }

}

// tslint:disable-next-line:variable-name
export const TicketServiceFactory = () => new TicketService();

export const ticketService = TicketServiceFactory();


// WEBPACK FOOTER //
// ./src/services/TicketService.ts